export default ({ app }) => {
  app.router.afterEach((to, from) => {
    const categoryPattern = /^page/
    const moreSeriePattern = /^moreSeries/
    if (!categoryPattern.test(to.name) && !moreSeriePattern.test(to.name)) {
      app.store.dispatch('page/clearPageContent')
    }
  })
}
